import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import tracking from '@/utils/tracking'
import MDReactComponent from 'markdown-react-js'

import LazyLoadImage from '@/components/atoms/LazyLoadImage'
import Card from '@/components/Card'

import './events-card-small.scss'

const EventsCardSmall = props => {
  const { className, key, bgColor, event, routeProps, lazyCallback } = props

  let title
  let eventKey
  let introduction
  let bodyCopy
  let bodyCopy2
  let legalCopy
  let imageCollection
  let heroData
  let lgHero
  let dfltHero
  let heroSrcSet
  let meta
  let startDate
  let endDate
  let ctaBookText
  let ctaBookLink
  let ctaBookAction

  for (let field of event) {
    if (field.id === 'eventtitle') {
      title = field.value
      continue
    } else if (field.id === 'urlslug') {
      eventKey = field.value
      continue
    } else if (field.id === 'introduction') {
      introduction = field.value
      continue
    } else if (field.id === 'heroimage') {
      for (let imgField of field.fields) {
        if (imgField.id === 'heroimagelarge_') {
          lgHero = imgField.imgURL
        }
      }
      for (let imgField of field.fields) {
        if (imgField.id === 'heroimagedefault') {
          dfltHero = imgField.imgURL
          break
        }
      }

      heroData = lgHero || dfltHero
      heroSrcSet = lgHero && dfltHero ? `${dfltHero} 750w, ${lgHero} 1984w` : ''
      continue
    } else if (field.id === 'metainformation') {
      meta = field.fields
      continue
    } else if (field.id === 'startdate') {
      startDate = moment(field.value, 'DD/MM/YYYY').format('MMM Do')
      continue
    } else if (field.id === 'enddate') {
      endDate = moment(field.value, 'DD/MM/YYYY').format('MMM Do')

      continue
    } else if (field.id === 'bodycopy') {
      bodyCopy = field.value
      continue
    } else if (field.id === 'bodycopy2') {
      bodyCopy2 = field.value
      continue
    } else if (field.id === 'imagecollection' && field.fields.length) {
      imageCollection = field.fields.filter((imgField) => imgField.imgURL !== '')
      continue
    } else if (field.id === 'legalcopy') {
      legalCopy = field.value
      continue
    } else if (field.id === 'cta-book') {
      for (let ctaField of field.fields) {
        if (ctaField.id === 'ctatext') {
          ctaBookText = ctaField.value
          continue
        } else if (ctaField.id === 'ctalink') {
          ctaBookLink = ctaField.value
          continue
        } else if (ctaField.id === 'ctaaction') {
          ctaBookAction = ctaField.value
          continue
        }
      }
      continue
    }
  }

  let humanReadableDate = startDate !== endDate ? `${startDate} - ${endDate}` : `${startDate}`

  return (
    <div className='events-card'>
      <Link
        to={`/events/${eventKey}`}
        onClick={() => window.scrollTo(0, 0)}
        className='events-card__link'
        onClick={() =>
          tracking.event('customEvent', {
            eventCategory: 'Events card',
            eventAction: 'click',
            eventLabel: `${title}, source: ${
              routeProps.location.pathname
            }`
          })
        }
      >
        <Card className={className} key={key} bgColor={bgColor}>
          <div className={'events-card__upper-wrap'}>
            <LazyLoadImage className='events-card__image'
              src={heroData}
              alt={title}
              lazyCallback={() => lazyCallback()}
            />
            <div className='events-card__date-wrap'>
              <span className='events-card__date'>
                <MDReactComponent text={humanReadableDate} />
              </span>
            </div>
          </div>
          <div className={'events-card__lower-wrap'}>
            <h3 className='events-card__title'>
              <span className='events-card__title-underline'>
                {title}
              </span>
            </h3>
          </div>
        </Card>
      </Link>
    </div>
  )
}

export default EventsCardSmall



// WEBPACK FOOTER //
// ./src/components/molecules/EventsCardSmall/index.js